import { Component, OnInit, Renderer2, ViewEncapsulation, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { DevelopmentService, UserService } from '@app/services';
import { ANALYTICS_DEVICE, PATH } from '@app/constants';
import { DevelopmentInfo, DevelopmentParticipations, UserInfo } from '@interfaces/app';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { PageTitleService } from '@app/services/page-title/page-title.service';

@Component({
   templateUrl: './project-info.component.html',
   styleUrls: ['./project-info.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class ProjectInfoComponent implements OnInit, AfterViewInit, OnDestroy {

   sub: { [prop: string]: Subscription } = {};

   totalPartsSameDev: number;

   shellContainer: Element;

   selectedIndex = 0;

   dev: DevelopmentInfo;
   user: UserInfo;
   devParts: DevelopmentParticipations;

   regaliaInfo: SafeUrl;

   showImageRegalia: boolean = false;

   allUsersParts: number;

   regaliaFrame: SafeUrl;

   width: number = window.innerWidth || 200;
   height: number = 850;

   devName: string;
   devPhase: string;

   pid: string;

   constructor(
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private devServ: DevelopmentService,
      private userServ: UserService,
      private render: Renderer2,
      private domSan: DomSanitizer,
      private pageTitle: PageTitleService,
   ) {
      this.pid = this.activatedRoute.snapshot.paramMap.get('pid');

      setTimeout(() => {
         if(this.dev?.newProject == null || this.dev?.newProject == undefined) {
         } else {
            let newProjectStatus = this.dev?.newProject?.status;

            if(newProjectStatus >= 4) {
               // Redirect to new interface project v2
               this.router.navigate([`${PATH.ROUTE_PROJECT_INFO_V2}/${this.pid}`]);
            }
         }

      }, 650)
   }

   selectedTabChange(event: MatTabChangeEvent) {
      this.selectedIndex = event.index;
   }

   ngOnInit(): void {
      if (this.pid) {
         this.sub.a = forkJoin({
            user: this.userServ.getOptionalUser(),
            dev: this.devServ.getDevelopmentInfo(this.pid),
            devParts: this.devServ.getDevelopmentParts(this.pid) }).subscribe({
            next: res => {
               this.dev = res.dev;
               this.user = res.user;
               this.devParts = res.devParts;

               // Assign dev name and phase
               this.devName = this.getDevName(this.dev.name);

               this.devPhase = this.getDevPhase(this.dev.name, this.dev.state);

               this.devServ.getTotalPartsUsers(this.dev.id).subscribe(res => {
                  this.allUsersParts = res;
               });

               this.pageTitle.setTitle(`Monific | ${this.dev.name}`);

               this.regaliaInfo = res.dev.regalia ? this.domSan.bypassSecurityTrustUrl(res.dev.regalia) : null;
               this.showImageRegalia = res?.dev?.showRegalia;
               this.regaliaFrame = res?.dev?.frameRegalia ? this.domSan.bypassSecurityTrustResourceUrl(res.dev.frameRegalia) : null;

               // this.totalPartsSameDev = r.user?.participations?.reduce((prev, cur) => prev += cur.devId === id ? cur.amount : 0, 0);

               // if (r.user?.participations) {
               //   for (var i = 0; i < r.user.participations.length; i++) {
               //     if (r.user?.participations[i].devId == id) {
               //       this.flag = true
               //     }
               //   }
               // }


            },
            error: () => this.router.navigate([PATH.ROUTE_DEVELOPMENTS_OPEN])
         });
      } else {
         this.router.navigate([PATH.ROUTE_DEVELOPMENTS_OPEN]);
      }

   }

   ngAfterViewInit(): void {
      //this.shellContainer = document.getElementsByClassName('content-shell')[0];
      //this.render.addClass(this.shellContainer, 'p-0');
      if(this.width > 992) {
         this.width = window.innerWidth - 250;
      }
   }

   ngOnDestroy(): void {
      //this.render.removeClass(this.shellContainer, 'p-0')
   }

   getDevName(name: string) {
      return name.split(' - ')[0];
   }
   getDevPhase(name: string, actualState: string) {
      const phase = name.split(' - ')[1];
      if (phase) {
         return actualState === 'residential' ? `Casa ${phase}` : `Campaña: ${phase}`;
      } else {
         return '';
      }
   }

}
